import React from 'react'
import { Typography, Box, Grid, Dialog, DialogContent, useMediaQuery, Divider, IconButton, Snackbar, Alert, CircularProgress, Button } from '@mui/material';
import CloseModalIcon from '../../../icons/close.svg'
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useStyles } from '../../../style/Pages/BasicCompanyInfo';
import CopyToClipboard from 'react-copy-to-clipboard';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { selectPaymentRequestsState, getPaymentRequestStatusType, PrStatusTypeDto, getPaymentRequestDetail, getResetPaymentRequestStatus } from '../sagas/paymentrequestslice';
import NumberFormat from 'react-number-format';
import { convertCentsToDollars } from '../../../shared/util/converters';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { PaymentRequestStatusType } from '@inosio/payments-sdk';
import { getRefundTrxDetails, selectRefundTrxDetails, getResetRefundTrxDetails, selectRefundTrxDetailsFetching } from '../../transactions/sagas/pmTransactionsSlice';



export interface DetailModalProps {
    open: boolean;
    onClose: () => void;
    TotalAmount: number;
    PayerName: string;
    PropertyName: string;
    CompanyName: string;
    Status: string;
    LastSentDate: string;
    PaymentRequestId: string;
}


const PaymentRequestDetailModal = (props: DetailModalProps) => {
    const [snackBarOpen, setSnackBarOpen] = React.useState(false);
    const { TotalAmount, PayerName, PropertyName, CompanyName, LastSentDate, PaymentRequestId, Status } = props
    const { isFetchingPaymentRequestDetail, PaymentRequestDetail, requestDetailsError, isFetchingPaymentRequestStatusDetails, isSuccessPaymentRequestStatusDetails, isPaymentRequestDetailSuccess } = useSelector(selectPaymentRequestsState)
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const refundDetails = useSelector(selectRefundTrxDetails);
    const isRefundDetailsFetching = useSelector(selectRefundTrxDetailsFetching);

    const style = {
        height: isOnMobileScreen ? '' : '555px'
    };
    const [value, setValue] = React.useState("1");
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    const classes = useStyles();
    const dispatch = useDispatch();
    const onBtnClick = () => {
        dispatch({
            type: getPaymentRequestStatusType.type,
            payload: {
                statusDescription: PaymentRequestStatusType.Cancelled,
                requestUuid: PaymentRequestId
            } as PrStatusTypeDto
        });
    }

    const onCloseClick = () => {
        props.onClose();
        dispatch({
            type: getResetRefundTrxDetails.type
        })
    }
    const handleAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarOpen(false);
    };

    React.useEffect(() => {
        if (isSuccessPaymentRequestStatusDetails) {
            dispatch({
                type: getPaymentRequestDetail.type,
                payload: PaymentRequestId
            })
        }
    }, [isSuccessPaymentRequestStatusDetails])

    React.useEffect(() => {
        if (isPaymentRequestDetailSuccess && Status === PaymentRequestStatusType.Completed) {
            dispatch(getRefundTrxDetails({ transactionUuid: PaymentRequestDetail?.TransactionUUID }))
        }

    }, [getRefundTrxDetails, isPaymentRequestDetailSuccess])

    React.useEffect(() => {
        if (props.open) {
            dispatch({
                type: getResetPaymentRequestStatus.type
            })
        }
    }, [props.open])

    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={() => {
                    onCloseClick()
                }}
                fullScreen={isOnMobileScreen}
                BackdropProps={{
                    invisible: false
                }}
                fullWidth={true}
                disableEnforceFocus
                style={{
                    background: "none",
                }}
                PaperProps={{
                    style: {
                        pointerEvents: "auto",
                        width: '520px',
                        borderRadius: '24px'
                    },
                }}
                disableEscapeKeyDown={true}
            >

                <DialogContent>
                    <Box
                        sx={style}
                    >
                        <Grid container spacing={1} justifyContent="center">
                            <Grid item xs={12} display='flex' justifyContent='center' alignItems='center' >
                                <Typography
                                    align='center'
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: "18px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}>
                                    {value === '1' && refundDetails ? `Payment ID: ${refundDetails.TransactionUuid || ''}` : `Payment Request ID: ${PaymentRequestId}`}
                                </Typography>
                                <Grid item>
                                    <CopyToClipboard text={value === '1' && refundDetails ? refundDetails.TransactionUuid  :PaymentRequestId}>
                                        <IconButton onClick={() => { setSnackBarOpen(true) }}>
                                            <ContentCopyIcon fontSize='small' />
                                        </IconButton>
                                    </CopyToClipboard>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} display='flex' justifyContent='center' >
                                <Typography
                                    align='center'
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: "16px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                        color: '#999999'
                                    }}>
                                    {LastSentDate ? `${moment(LastSentDate).format("LLLL")}` : ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} display='flex' justifyContent='center' >
                                <Typography
                                    align='center'
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: "16px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}>
                                    {PaymentRequestDetail?.Status}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} display='flex' justifyContent={'space-between'}>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}>
                                    {CompanyName}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}>
                                    {PropertyName}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} display='flex' justifyContent={'flex-start'}>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}>
                                    {PayerName}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }} mt={2}>
                                {requestDetailsError?.message?.length ?
                                    <div className={classes.globalError} >
                                        <Typography
                                            style={{
                                                fontFamily: "'Open Sans', sans-serif",
                                                fontStyle: 'normal',
                                                fontWeight: 500,
                                                fontSize: '14px',
                                                lineHeight: '18px',
                                                color: '#DB3939'
                                            }}>
                                            Something went wrong. Please try again later or contact support.
                                        </Typography>
                                    </div> : ""
                                }
                            </Grid>
                            <Box sx={{ width: "100%" }}>
                                {PaymentRequestDetail?.Status === 'Completed' ?
                                    <TabContext value={value} >
                                        <Grid item display='flex' justifyContent='center'>
                                            <Box >
                                                <TabList onChange={handleChange} >
                                                    <Tab label="Summary" value="1" style={{ marginRight: "70px", textTransform: "none" }} />
                                                    <Tab label="Request Details" value="2" style={{ textTransform: "none" }} />
                                                </TabList>
                                            </Box>
                                        </Grid>
                                        <Box sx={{ width: "100%" }}>
                                            <TabPanel value="1" >
                                                { isRefundDetailsFetching ?<Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }} mt={2}>
                                                    <CircularProgress size={40} />
                                                </Grid>
                                                :
                                                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                                    <Grid item xs={7}>
                                                        <Typography id="review-submit-bank-details-text"> Payment Method</Typography>
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <Typography id="review-submit-sub-bank-details">{refundDetails?.PayMethodLastFour}</Typography>
                                                    </Grid>
                                                    <Grid item xs={7}>
                                                        <Typography id="review-submit-sub-details">Leaseholder Name</Typography>
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <Typography id="review-submit-sub-details">{refundDetails.PayerName}</Typography>
                                                    </Grid>
                                                    {
                                                        refundDetails?.PayFields?.map((payfield, index) => {
                                                            if (payfield.Amount === 0) return null;
                                                            return (
                                                                <React.Fragment key={index}>
                                                                    <Grid item xs={7}>
                                                                        <Typography id="review-submit-sub-details">{payfield.Description}</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={5}>
                                                                        <Typography id="review-submit-sub-details">
                                                                            <NumberFormat
                                                                                thousandsGroupStyle="thousand"
                                                                                value={convertCentsToDollars(payfield.Amount)}
                                                                                prefix="$"
                                                                                decimalSeparator="."
                                                                                displayType="text"
                                                                                type="text"
                                                                                thousandSeparator={true}
                                                                                allowNegative={true}
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={true}
                                                                            />
                                                                        </Typography>
                                                                    </Grid>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    <Grid item xs={7}>
                                                        <Typography id="review-submit-sub-details">Fee Amount</Typography>
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <Typography id="review-submit-sub-details">
                                                            <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={convertCentsToDollars(refundDetails?.Fees || 0)}
                                                                prefix="$"
                                                                decimalSeparator="."
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={true}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                            />
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={7}>
                                                        <Typography id="review-submit-sub-details">Total Amount</Typography>
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <Typography id="review-submit-sub-details">
                                                            <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={convertCentsToDollars(refundDetails?.Amount + (refundDetails?.Fees || 0))}
                                                                prefix="$"
                                                                decimalSeparator="."
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={true}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                            />
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={7}>
                                                        <Typography id="review-submit-sub-details">Transaction Date</Typography>
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <Typography id="review-submit-sub-details">{moment(refundDetails?.TransactionDate).format("L")}</Typography>
                                                    </Grid>
                                                </Grid>}
                                            </TabPanel>
                                        </Box>
                                        <TabPanel value="2">
                                            {isFetchingPaymentRequestDetail ?
                                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }} mt={2}>
                                                    <CircularProgress size={40} />
                                                </Grid>
                                                :
                                                <Grid item xs={12} sx={{
                                                    maxHeight: "180px",
                                                    overflow: 'auto',
                                                    "&::-webkit-scrollbar": {
                                                        width: 7,
                                                    },
                                                    "&::-webkit-scrollbar-track": {
                                                        boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                                                        borderRadius: '24px',
                                                    },
                                                    "&::-webkit-scrollbar-thumb": {
                                                        backgroundColor: "darkgrey",
                                                        borderRadius: '24px',
                                                    }
                                                }}>
                                                    {
                                                        PaymentRequestDetail?.RequestDetails?.map((req, index) => {
                                                            return (
                                                                <Grid item xs={12} key={index}>
                                                                    <Grid item xs={12} display='flex' justifyContent={'space-between'} ml={1} mr={2}>
                                                                        <Grid item xs={9.5}>
                                                                            <Typography
                                                                                sx={{
                                                                                    fontWeight: 600,
                                                                                    fontSize: "16px",
                                                                                    lineHeight: "22px",
                                                                                    fontFamily: "Work Sans",
                                                                                    color: '#D3D3D3'
                                                                                }}>
                                                                                {req.Description}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item xs={2.5}>
                                                                            <Typography
                                                                                sx={{
                                                                                    fontWeight: 400,
                                                                                    fontSize: "16px",
                                                                                    lineHeight: "22px",
                                                                                    fontFamily: "Work Sans",
                                                                                    color: '#D3D3D3'
                                                                                }}>
                                                                                <NumberFormat
                                                                                    thousandsGroupStyle="thousand"
                                                                                    value={convertCentsToDollars(req.Amount)}
                                                                                    prefix="$"
                                                                                    decimalSeparator="."
                                                                                    displayType="text"
                                                                                    type="text"
                                                                                    thousandSeparator={true}
                                                                                    allowNegative={true}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale={true}
                                                                                />
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item xs={12} mt={1} mb={1} mr={1}>
                                                                        {<Divider sx={{ width: '100%' }} />}
                                                                    </Grid>
                                                                </Grid>
                                                            )
                                                        })
                                                    }
                                                </Grid>}
                                        </TabPanel>
                                    </TabContext>
                                    :
                                    isFetchingPaymentRequestDetail ?
                                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }} mt={2}>
                                            <CircularProgress size={40} />
                                        </Grid>
                                        :
                                        <Grid item xs={12} sx={{
                                            maxHeight: "245px",
                                            overflow: 'auto',
                                            "&::-webkit-scrollbar": {
                                                width: 7,
                                            },
                                            "&::-webkit-scrollbar-track": {
                                                boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                                                borderRadius: '24px',
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                                backgroundColor: "darkgrey",
                                                borderRadius: '24px',
                                            }
                                        }}>
                                            {
                                                PaymentRequestDetail?.RequestDetails?.map((req, index) => {
                                                    return (
                                                        <Grid item xs={12} key={index}>
                                                            <Grid item xs={12} display='flex' justifyContent={'space-between'} ml={1} mr={2}>
                                                                <Grid item xs={9.5}>
                                                                    <Typography
                                                                        sx={{
                                                                            fontWeight: 600,
                                                                            fontSize: "16px",
                                                                            lineHeight: "22px",
                                                                            fontFamily: "Work Sans",
                                                                            color: '#D3D3D3'
                                                                        }}>
                                                                        {req.Description}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={2.5}>
                                                                    <Typography
                                                                        sx={{
                                                                            fontWeight: 400,
                                                                            fontSize: "16px",
                                                                            lineHeight: "22px",
                                                                            fontFamily: "Work Sans",
                                                                            color: '#D3D3D3'
                                                                        }}>
                                                                        <NumberFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={convertCentsToDollars(req.Amount)}
                                                                            prefix="$"
                                                                            decimalSeparator="."
                                                                            displayType="text"
                                                                            type="text"
                                                                            thousandSeparator={true}
                                                                            allowNegative={true}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                        />
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12} mt={1} mb={1} mr={1}>
                                                                {<Divider sx={{ width: '100%' }} />}
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid>
                                }
                            </Box>
                            <Grid item sx={{ position: 'absolute', bottom: requestDetailsError?.message?.length || PaymentRequestDetail?.Status === 'Completed' ? 30 : 50, width: '100%' }} >
                                <Divider />
                                <Grid container display='flex' justifyContent='space-between'>
                                    <Grid mt={2} mb={2}>
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "18px",
                                                lineHeight: "22px",
                                                fontFamily: "Work Sans",
                                                marginLeft: '10px'
                                            }}>
                                            Total
                                        </Typography>
                                    </Grid>
                                    <Grid item p={2}>
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "18px",
                                                lineHeight: "22px",
                                                fontFamily: "Work Sans",
                                            }}>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={convertCentsToDollars(PaymentRequestDetail?.Status === "Completed" && value === '1' ? refundDetails?.Amount + (refundDetails?.Fees || 0) : TotalAmount)}
                                                prefix="$"
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={true}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                            />
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item sx={{ position: 'absolute', top: 18, right: 20 }}>
                            <img src={CloseModalIcon} alt="close" style={{ cursor: 'pointer' }} onClick={() => {
                                onCloseClick()
                            }} />
                        </Grid>
                    </Box>
                    {
                        PaymentRequestDetail?.Status === 'Pending' ? <Grid item sx={{ position: 'absolute', bottom: 12, left: 12 }}>
                            {
                                isFetchingPaymentRequestStatusDetails || isSuccessPaymentRequestStatusDetails ? <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", height: "50px", width: "60px" }} mt={2}>
                                    <CircularProgress size={30} />
                                </Grid> :
                                    <Button variant="outlined"
                                        style={{
                                            borderRadius: "24px",
                                            textTransform: "capitalize",
                                            color: "#DB3939",
                                            borderColor: "#DB3939",
                                            height: '30px',
                                            width: '150px',
                                        }} onClick={onBtnClick} >
                                        Cancel Request
                                    </Button>
                            }

                        </Grid> : ''
                    }
                </DialogContent>

            </Dialog >
            <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={snackBarOpen} autoHideDuration={4000} onClose={handleAlertClose}>
                <Alert onClose={handleAlertClose} severity="success" sx={{ width: '100%' }}>
                    Copied to clipboard
                </Alert>
            </Snackbar>
        </React.Fragment >
    )
}

export default PaymentRequestDetailModal;
